/* @flow */
import cx from 'classnames';
import Image from 'components/Image.jsx';
import React from 'react';
import './styles/ChatWelcomeMessage.scss';

class ChatWelcomeMessage extends React.Component {
  static propTypes = {
    firstHeader: React.PropTypes.node,
    secondHeader: React.PropTypes.node,
    heroImage: React.PropTypes.any,
  };

  render() {
    const { firstHeader, secondHeader, heroImage } = this.props;
    if (!firstHeader || !secondHeader) {
      return null;
    }

    return (
      <div className={cx('ChatWelcomeMessage', this.props.className)}>
        <Image
          className="ChatWelcomeMessage-hero"
          src={heroImage}
        />
        <div className="ChatWelcomeMessage-nuxH1">Welcome!</div>
        <div className="ChatWelcomeMessage-nuxH2">
          {firstHeader}
        </div>
        <div className="ChatWelcomeMessage-nuxH3">
          {secondHeader}
        </div>
      </div>
    );
  }
}

export default ChatWelcomeMessage;



// WEBPACK FOOTER //
// ./src/chat/components/ChatWelcomeMessage.jsx